import { render } from "./PopUpShareFile.vue?vue&type=template&id=25b171bf"
import script from "./PopUpShareFile.vue?vue&type=script&lang=js"
export * from "./PopUpShareFile.vue?vue&type=script&lang=js"

import "./PopUpShareFile.vue?vue&type=style&index=0&id=25b171bf&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__